module.exports = __webpack_public_path__ + "static/img/couch3.dde3b0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/drawing_painting/couch/couch3.jpg
// module id = Gq5S
// module chunks = 1